let isSafari: boolean | undefined;

const useIsSafari = () => {
    if (typeof isSafari === 'undefined') {
        isSafari =
            navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Chrome') <= -1;
    }

    return isSafari;
};

export default useIsSafari;
